// extracted by css-extract-rspack-plugin
export default {"title":"Title-module__title__l2iYxiv","link":"Title-module__link__VKFqlR2"};